// extracted by mini-css-extract-plugin
export default {"section":"PO8_4cLeGDwLQ75mDlpg","container":"RISIBTKvNJkMuenwj80o","title":"N3pnJR34tg7qvK1gVosQ","actions":"DSDU8_OSfcNy_p2z4O7O"};